import { projectContext } from '@/layouts/MainLayout'
import { filterMembersByGroupName, getProjectMembers } from '@/services/member/member'
import { useRequest } from 'ahooks'
import { memo, useContext, useMemo } from 'react'
import ProjectMemberTable from '../components/ProjectMemberTable'
import { selectUser } from '@/store/user/user.slice'
import { useSelector } from 'react-redux'

export default memo(function ProjectMembers() {
  const { projectId, projectData } = useContext(projectContext)
  const { data = [], run: refresh, loading } = useRequest(() => getProjectMembers(projectId))
  const user = useSelector(selectUser)

  const members = filterMembersByGroupName(data, 'DEFAULT_MEMBER')

  const me = useMemo(() => {
    return data.find(item => item.email === user.userInfo?.email)
  }, [data, user])

  return <ProjectMemberTable
    me={me}
    members={members} reload={refresh} loading={loading} project={projectData} />
})
